module.exports = __webpack_public_path__ + "static/media/repeat.6ec5bad1.svg";